/**
 * Environment Configuration — Cloud Run (BFF on GCP) + staging Domain Orch
 *
 * @author Veerendra
 * @date 2026-03-23
 * @version 1.0
 * @description Build with `ng build --configuration=cloudrun` or `npm run build:cloudrun`
 */

import type { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  hideInternalAgentDiagnostics: true,
  /** AI Agent BFF on Cloud Run — chat uses `fetch` + SSE to `POST …/agent/chat` / `…/agent/chat/:id`. */
  // BFFOrchApiUrl: 'https://bffagent-node-548825020963.us-central1.run.app/api/node',
  BFFOrchApiUrl: '/bff-api',
  domainOrchApiUrl: '/api',

  appName: 'ATS Ceipal Agent',
  appVersion: '1.0.0',
  listingApiUrl: 'https://aiagentservicestg.ceipal.com/api',

  // Feature Flags
  enableLogging: true,
  enableErrorReporting: true,
  enableAnalytics: true,

  enableMockData: false,
  enableHttpLogging: true,
  enablePerformanceMonitoring: true,
  defaultATSHost: 'https://thgcloudstg.ceipal.com',

  payloadEncryptionEnabled: false,
  payloadEncryptionKeyBase64: '',

  agenticAiApiPrefix: 'agentic-ai',
  agenticAiUseMock: false,

  /** /workflow-builder always requires an ATS session outside local development. */
  allowWorkflowBuilderWithoutSession: false,

  amChartsLicenseKey: 'AM5C-228909170',
};
